module.exports = __webpack_public_path__ + "static/media/twitter.0729c42a.svg";